import React from "react";
import Button from "~/components/elements/Button";
import { useTranslation } from "react-i18next";

export default function ErrorPage() {
  const { t } = useTranslation();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex h-dvh flex-col items-center justify-center p-4 text-center">
      <h1 className="mb-4 text-lg">{t("shared.errors.title")}</h1>
      <p>{t("shared.errors.description")}</p>
      <p className="mb-8">{t("shared.errors.contact_us")}</p>
      <Button label={t("shared.errors.refresh")} onClick={handleReload} />
    </div>
  );
}
